import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChromePlatingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Chrome plating" }),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4,
			strokeLinejoin: "round",
			strokeLinecap: "round",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "m9 62 41-24 41 24v5L50 91 9 67Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m9 62 41 24 41-24M50 86v5",
					fill: "none"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "icon-outline",
					opacity: .18,
					stroke: "none",
					d: "m50 40 38 22-38 22-13-8Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m23 61 12 7m7 4 8 5 19-11",
					fill: "none"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "none",
			stroke: "var(--icon-highlight)",
			strokeWidth: 2.4,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "m53 8 4 12 12 4-12 4-4 12-4-12-12-4 12-4Z"
				}),
				/* @__PURE__ */ _jsx("path", { d: "M78 31v10m-5-5h10M26 30v8m-4-4h8" }),
				/* @__PURE__ */ _jsx("path", { d: "m38 57 12-7 12 7m-24 7 12 7 12-7" })
			]
		})
	]
});
export default SvgChromePlatingSm;
